const config = {
  apiUrl: process.env.REACT_APP_API_URL,
  get token() {
    return localStorage.getItem('authToken');
  },
  defaultImage: '/images/default-image.png',
}

export default config;